import { render, staticRenderFns } from "./cashierBoxStatement.vue?vue&type=template&id=50e8ae6c&"
import script from "./cashierBoxStatement.vue?vue&type=script&lang=js&"
export * from "./cashierBoxStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports